export const MeetingState_Both_OtherCancelled = [
    '$scope', function($scope) {
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/consultations/meetingStates/both/otherCancelled.html';
    },
];
